import { checkSymbolSearch } from "@shared/utils/misc";
import { getLocaleStringWithPrecision, toFixed } from "@shared/utils/numbers";

export type TableSearchValue =
  | string
  | number
  | null
  | undefined
  | TableSearchValue[];

const normalizeSearchText = (text: string): string =>
  text
    .toLowerCase()
    .replace(/[+$₿]/g, "")
    .replace(/−/g, "-")
    .replace(/\s+%/g, "%")
    .trim();

const getSearchTexts = (value: TableSearchValue): string[] => {
  if (Array.isArray(value)) return value.flatMap(getSearchTexts);
  if (typeof value === "number") {
    return Number.isFinite(value)
      ? [
          String(value),
          getLocaleStringWithPrecision(value),
          getLocaleStringWithPrecision(value, 2, true),
        ]
      : [];
  }
  return typeof value === "string" ? [value] : [];
};

export const getPercentSearchValues = (value?: number): TableSearchValue[] =>
  value === undefined
    ? []
    : [value, `${toFixed(value, 2)}%`, `${value.toFixed(2)}%`];

export const checkTableRowSearch = (
  symbol: string,
  search: string | undefined,
  values: TableSearchValue[]
): boolean => {
  const query = normalizeSearchText(search ?? "");
  if (!query || checkSymbolSearch(symbol, query)) return true;
  return values
    .flatMap(getSearchTexts)
    .some((value: string) => normalizeSearchText(value).includes(query));
};
